import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OrderList from '../components/Orders/OrderList';  // Import the OrderList component
import OrderForm from '../components/Orders/NewOrderForm';  // Import the OrderForm component

const OrdersPage = () => {
    return (
        <div data-testid="orders-page">
            <Routes>
                <Route path="/" element={<OrderList />} />  {/* List of all orders */}
                <Route path="/new" element={<OrderForm />} />  {/* Create new order */}
                <Route path="/:id/edit" element={<OrderForm />} />  {/* Edit order */}
            </Routes>
        </div>
    );
};

export default OrdersPage;
